import React, { FC, ReactNode } from 'react';
import useAccordion from '../../../hooks/use-accordion/use-accordion';
import AccordionItem from '../../atoms/accordion-item/accordion-item';

interface Props {
  readonly allowMultiSelect?: boolean;
  readonly className?: string;
  readonly items: {
    readonly body: ReactNode;
    readonly heading: string;
  }[];
  readonly onClick?: (heading: string) => void;
}

const Accordion: FC<Props> = ({
  allowMultiSelect,
  className,
  items,
  onClick,
}: Props) => {
  const { toggleSelectedItem, selectedItems } =
    useAccordion<number>(allowMultiSelect);

  return (
    <div className={className}>
      {items.map(
        (item: { body: ReactNode; heading: string }, index: number) => (
          <AccordionItem
            key={item.heading}
            active={selectedItems.includes(index)}
            heading={item.heading}
            onClick={() => {
              toggleSelectedItem(index);
              onClick(item.heading);
            }}
          >
            {item.body}
          </AccordionItem>
        )
      )}
    </div>
  );
};

Accordion.defaultProps = {
  allowMultiSelect: true,
  className: '',
  onClick: () => ({}),
};

export default Accordion;
